import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import api from "@/lib/api";
import { House, Users, ClockCounterClockwise, Money, ChatCircle, Megaphone, Calendar, ChartBar, Bell, Gear, ClipboardText, CalendarBlank, ChartLine } from "@phosphor-icons/react";

const NAV_ITEMS = [
  { to: "/", label: "Anasayfa", icon: House },
  { to: "/personnel", label: "Personel", icon: Users },
  { to: "/leaves", label: "İzinler", icon: ClockCounterClockwise },
  { to: "/payroll", label: "Ücret Pusulaları", icon: Money },
  { to: "/messages", label: "Mesajlar", icon: ChatCircle },
  { to: "/announcements", label: "Duyurular", icon: Megaphone },
  { to: "/calendar", label: "Takvim", icon: Calendar },
  { to: "/reports", label: "Raporlar", icon: ChartBar },
  { to: "/notifications", label: "Bildirimler", icon: Bell },
  { to: "/settings", label: "Ayarlar", icon: Gear },
  { to: "/audit", label: "Denetim Kayıtları", icon: ClipboardText },
  { to: "/shifts", label: "Vardiya Planı", icon: CalendarBlank },
  { to: "/surveys", label: "Anketler", icon: ChartLine },
];

export default function CommandPalette({ open, onOpenChange }) {
  const nav = useNavigate();
  const [personnel, setPersonnel] = useState([]);

  useEffect(() => {
    if (open) {
      api.get("/personnel").then((r) => setPersonnel(r.data)).catch(() => {});
    }
  }, [open]);

  const go = (path) => { onOpenChange(false); nav(path); };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Ara: sayfa, personel, işlem..." data-testid="cmdk-input" />
      <CommandList>
        <CommandEmpty>Sonuç yok.</CommandEmpty>
        <CommandGroup heading="Sayfalar">
          {NAV_ITEMS.map((n) => (
            <CommandItem key={n.to} onSelect={() => go(n.to)} data-testid={`cmdk-nav-${n.to.replace('/','') || 'home'}`}>
              <n.icon size={16} className="mr-2" /> {n.label}
            </CommandItem>
          ))}
        </CommandGroup>
        {personnel.length > 0 && (
          <CommandGroup heading="Personel">
            {personnel.slice(0, 20).map((p) => (
              <CommandItem key={p.id} onSelect={() => go("/personnel")}>
                <Users size={16} className="mr-2" /> {p.first_name} {p.last_name} — {p.department}
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
